export type PasswordGateSession = {
  authenticated: boolean
  configured?: boolean
}

export type PasswordGateLogin = {
  authenticated: boolean
}

export const getPasswordGateSession = async (): Promise<PasswordGateSession> => {
  const response = await fetch('/api/password-gate/session', {
    method: 'GET',
    credentials: 'include',
  })

  if (!response.ok) {
    throw new Error('Unable to validate password gate session')
  }

  return response.json()
}

export const loginPasswordGate = async (password: string): Promise<PasswordGateLogin> => {
  const response = await fetch('/api/password-gate/login', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ password }),
  })

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    const errorMessage = typeof data.error === 'string' ? data.error : 'Incorrect password'
    throw new Error(errorMessage)
  }

  return response.json()
}
